import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
	Welcome,
	FreeVsPro,
	Settings,
	StarterTemplates,
	CustomLayouts,
	SpectraScreen,
	ExtensionScreen,
	Docs,
} from "@DashboardApp/pages";

// Define a mapping of paths to components.
const ROUTE_MAP = {
	"getting-started": Welcome,
	"starter-templates": StarterTemplates,
	settings: Settings,
	"free-vs-pro": FreeVsPro,
	"custom-layouts": CustomLayouts,
	spectra: SpectraScreen,
	woocommerce: ExtensionScreen,
	docs: Docs,
};

function SettingsRoute() {
	const { search } = useLocation();
	const query = new URLSearchParams(search);
	const page = query.get("page");
	const path = query.get("path");

	useEffect(() => {
		if (typeof astWpMenuClassChange === "function") {
			astWpMenuClassChange(path);
		}
	}, [path]);

	if (astra_admin.home_slug !== page) {
		return <p>Fallback Route Page</p>;
	}

	const Component = ROUTE_MAP[path] || Welcome;

	return <Component />;
}

export default SettingsRoute;
